module.exports = __webpack_public_path__ + "static/media/dingdong.4c7ac55b.wav";